<script setup lang="ts">
import { useAuth } from "~/composables/auth/useAuth";
import { useFetchProfile } from "~/composables/auth/useFetchProfile";

useHead({
  bodyAttrs: {
    class: "dark:bg-gray-950",
  },
});

const { user, fetchUserProfile } = useFetchProfile();
const { logout } = useAuth();

onMounted(() => {
  const path = useRoute().path;
  if (path.includes("/login") || path.includes("/signup") || path.includes("/callback") || path.includes("verify-email") || path.includes("forgot-password") || path.includes("reset-password")) return;
  fetchUserProfile();
});
</script>

<template>
  <div class="h-screen flex items-center justify-center overlay">
    <div class="gradient" />

    <UButton label="Log out" color="gray" variant="soft" class="absolute top-4 left-4" @click="logout"
      v-if="user?.id" />

    <div class="absolute top-6 right-6" v-if="user?.id">
      <div class="text-xs text-gray-500 dark:text-gray-400">Logged in as</div>
      <div class="text-sm">{{ user.email }}</div>
    </div>

    <slot />
  </div>
</template>

<style scoped>
.gradient {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(50% 50% at 50% 50%, rgb(var(--color-primary-500) / 0.25) 0, #FFF 100%);
}

.dark {
  .gradient {
    background: radial-gradient(50% 50% at 50% 50%, rgb(var(--color-primary-400) / 0.1) 0, rgb(var(--color-gray-950)) 100%);
  }
}

.overlay {
  background-size: 100px 100px;
  background-image:
    linear-gradient(to right, rgb(var(--color-gray-200)) 0.5px, transparent 0.5px),
    linear-gradient(to bottom, rgb(var(--color-gray-200)) 0.5px, transparent 0.5px);
}

.dark {
  .overlay {
    background-image:
      linear-gradient(to right, rgb(var(--color-gray-900)) 0.5px, transparent 0.5px),
      linear-gradient(to bottom, rgb(var(--color-gray-900)) 0.5px, transparent 0.5px);
  }
}
</style>
